module.exports = __webpack_public_path__ + "static/media/Postales-06.74e0350f.png";